import { getPointSymbolLayerConfig, MAP_HOVERED_ICON_SIZE, MAP_NORMAL_ICON_SIZE } from "@l2r-front/l2r-map"

export function getCampaignItemsLayerStyle(hovered = false) {
    const layerStyle = getPointSymbolLayerConfig({
        layout: {
            "icon-size": hovered ? MAP_HOVERED_ICON_SIZE : MAP_NORMAL_ICON_SIZE,
            "icon-image": ["get", "icon", ["properties"]],
        },
    })
    return layerStyle
}